import request from '@/utils/request'

/**
 * 获取验证码
 */
export function getCaptcha() {
  return request({
    url: '/auth/captcha',
    method: 'get'
  })
}

/**
 * 用户登录
 */
export function login(data) {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  return request({
    url: '/api/auth/info',
    method: 'get'
  })
} 

/**
 * 从localStorage获取用户id
 */
export function getUserId() {
  return localStorage.getItem('userId')
}

/**
 * 从localStorage获取用户名
 */
export function getUserName() {
  return localStorage.getItem('userName')
}

